// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"be9237c1","412":"7d9f479d","457":"334c84dc","459":"5f8dc172","926":"e0f6c30f"}[chunkId] + ".css";
};